<template>
  <div class="flex items-start w-full bg-wcLightGrey max-h-full flex-col overflow-y-auto">
    <RecruiterNav id="recruiter-navbar" class="w-full bg-white"  :user="userDetails"/>
    <div id="container-div" class="w-full bg-wcLightGrey transition duration-200 flex max-w-screen-2xl mx-auto" style="overflow:hidden; max-height: calc(100vh - 3.5rem);">
      <RecruiterSettings />
      <FadeTransition :duration="200" origin="center top" mode="out-in">
        <RouterView class="overflow-y-scroll content-scroll[6px] bg-wcLightGrey w-full p-4"></RouterView>
      </FadeTransition>
    </div>
  </div>
</template>

<script lang="ts">
import { FadeTransition } from 'vue2-transitions'
import RecruiterNav from '@/components/RecruiterNavbar/RecruiterNav.vue'
import RecruiterSettings from '@/components/RecruiterSettings/RecruiterSettings.vue'
import { UserModule } from '@/store/modules/user'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'RecruiterSettingsDashboard',
  components: {
    FadeTransition,
    RecruiterNav,
    RecruiterSettings
  }
})
export default class extends Vue {
  private companyId = '';
  private userDetails = {};

  mounted(): void {
    this.getCompanyId()
  }

  async getCompanyId(): Promise<void> {
    this.companyId = UserModule.companyId || ''
    this.userDetails = {
      username: UserModule.name,
      email: UserModule.email,
      avatar: UserModule.avatar
    }
  }
}
</script>
